import Vue from 'vue';
import App from './App.vue';
import router from './router';
import Config from './utils/Config';
import store from './store';

import './less/index.less';

Config.init();
Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
	//If first route, wait for data to be loaded
	if (!store.state.initComplete) {
		store.dispatch("startApp", { route: to }).then(_ => {
			next();
		});
	}else{
		next();
	}
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
